export default {
  allTolls: [],
}
